// Lifts the Gorgias chat button and Klaviyo teaser above Horizon's sticky add-to-cart bar while it is showing.
// Sets html.lytes-atc-stuck plus --lytes-atc-lift (bar height + its bottom offset); lytes.css does the moving.
(function () {
  function init(bar) {
    var root = document.documentElement;
    function update() {
      var stuck = bar.getAttribute('data-stuck') === 'true' && getComputedStyle(bar).display !== 'none';
      if (stuck) {
        var lift = bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0);
        root.style.setProperty('--lytes-atc-lift', lift + 'px');
      }
      root.classList.toggle('lytes-atc-stuck', stuck);
    }
    new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    window.addEventListener('resize', update);
    update();
  }
  function start() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar) init(bar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
